import React, {Component} from 'react';
import {Helmet} from 'react-helmet';
import {Modal} from 'reactstrap';
import ConsentManager from '../../../ConsentManager/ConsentManager';
import Cookies from 'js-cookie';
import { Personalization, statisticTracking } from "../../../../shared/trackingScripts";

class ConsentModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: true,
            statisticScript: '',
            personalizationScript: ''
        };

        this.toggle = this.toggle.bind(this);
        this.consentCallback = this.consentCallback.bind(this);
        this.statisticHandler = this.statisticHandler.bind(this);
    }

    toggle = () => {
        this.setState({
            modal: !this.state.modal
        })
    };

    consentCallback = (consentState) => {
        // Update all cookies based on the state
            if (consentState.statisticCheck) {
                    this.statisticHandler();
            Cookies.set('bigfoot_statistic-consent', true, { expires: 180 });
                } else {
            Cookies.set('bigfoot_statistic-consent', false, { expires: 180 });
        }

        if (consentState.personalizationCheck) {
                    this.personalizationHandler();
            Cookies.set('bigfoot_personalization-consent', true, { expires: 180 });
            } else {
            Cookies.set('bigfoot_personalization-consent', false, { expires: 180 });
            this.setState({ personalizationScript: null });
            }

        // Performance check logic (commented out in original, keeping structure)
        // if (consentState.performanceCheck) { ... }

        this.toggle();
    };

    statisticHandler = () => {
        let statisticScript = statisticTracking();

        this.setState({ statisticScript: statisticScript });
    };

    personalizationHandler = () => {
        let personalizationScript = <Personalization />;


        this.setState({ personalizationScript: personalizationScript });
    };

    render() {
        return (
            <React.Fragment>
                <Helmet>{this.state.statisticScript}</Helmet>
                {this.state.personalizationScript}
                <Modal size="lg" scrollable backdrop={'static'} keyboard={false} isOpen={this.state.modal} toggle={this.toggle}>
                    <ConsentManager consentCallback={this.consentCallback} pages={this.props.pages}/>
                </Modal>
            </React.Fragment>
        )
    }
}

export default ConsentModal;


